import { useEffect } from "react";

import { NavProfile } from "constants/field-values";
import { useNavProfile } from "hooks/useNavProfile";

const OLLIE_FAVICON_PATH = `${process.env.PUBLIC_URL}/assets/ollie/favicon-64x64.png`;

const setIconHref = (rel: string, href: string) => {
	document.querySelectorAll<HTMLLinkElement>(`link[rel="${rel}"]`).forEach(link => {
		link.href = href;
		link.type = "image/png";
	});
};

/**
 * Swaps the tab icon while the Ollie nav profile is active.
 * The other profiles keep the icons that index.html sets for the brand.
 * The tab title is set by usePageTitle.
 */
export const useNavProfileBranding = () => {
	const { navProfile } = useNavProfile();
	const isOllieProfile = navProfile.id === NavProfile.Ollie;

	useEffect(() => {
		if (!isOllieProfile) {
			return;
		}

		const previousIcons = Array.from(
			document.querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="apple-touch-icon"]')
		).map(link => ({ link, href: link.href, type: link.type }));

		setIconHref("icon", OLLIE_FAVICON_PATH);
		setIconHref("apple-touch-icon", OLLIE_FAVICON_PATH);

		return () => {
			previousIcons.forEach(({ link, href, type }) => {
				link.href = href;
				link.type = type;
			});
		};
	}, [isOllieProfile]);
};
